import React from "react";

import useStyles from "./styles";

export interface UITabFooterProps {
  children?: JSX.Element;
}

export const UITabFooter: React.FC<UITabFooterProps> = (props) => {
  const { children } = props;
  const classes = useStyles();

  return (
    <div data-cy="UI-buttons" className={classes.mainDiv}>
      {children}
    </div>
  );
};
